// @flow

import * as React from 'react';
import DropDownInput from "./DropDownInput";
import NumberInput from "./NumberInput";
import TubesInput from "./TubesInput";
import OptionManager from "../common/OptionManager";
import DependencyManager from "../common/DependencyManager";

import type { NumTubesCallback } from "./TubesInput"
import type {ComponentMeta, UnmountHandler} from "../common/CommonTypes";
import CalculationSectionHeader from "./CalculationSectionHeader";
import ReactAI from 'react-appinsights';

type Props = {
    optionManager: OptionManager,
    dependencyManager: DependencyManager,

    onChange: (event: SyntheticEvent<>) => void,
    onBlur: (event: SyntheticEvent<>) => void,
    onUnmount: UnmountHandler,
    addTube: NumTubesCallback,
    removeTube: NumTubesCallback,

    pointShafts: number,
    metersLongerBottomLengthThanWidth: number,
    shaftDepthM: number,
    slopeAngleN1: number,
    shaftCapacityM3PerHour: number,
    shaftLengthM: number,

    pointShaftsMeta: ComponentMeta,
    metersLongerBottomLengthThanWidthMeta: ComponentMeta,
    shaftDepthMMeta: ComponentMeta,
    slopeAngleN1Meta: ComponentMeta,
    shaftCapacityM3PerHourMeta: ComponentMeta,
    shaftLengthMMeta: ComponentMeta,

    numTubes: number,
    numTubesName: string,
    tubeValuesNamePrefix: string,
    tubeValues: {[valueName: string]: number},
    tubeMetas: {[valueName: string]: ComponentMeta},

    diaByTubeType: number[],

    phaseNr: number,


};

class CalculationInsertionFlexibleLiningInput extends React.Component<Props> {

    render() {

        const optionManager = this.props.optionManager;
        const dependencyManager = this.props.dependencyManager;

        const onChange = this.props.onChange;
        const onBlur = this.props.onBlur;
        const onUnmount = this.props.onUnmount;
        const addTube = this.props.addTube;
        const removeTube = this.props.removeTube;

        const pointShafts = this.props.pointShafts;
        const metersLongerBottomLengthThanWidth = this.props.metersLongerBottomLengthThanWidth;
        const shaftDepthM = this.props.shaftDepthM;
        const slopeAngleN1 = this.props.slopeAngleN1;
        const shaftCapacityM3PerHour = this.props.shaftCapacityM3PerHour;

        const pointShaftsMeta = this.props.pointShaftsMeta;
        const metersLongerBottomLengthThanWidthMeta = this.props.metersLongerBottomLengthThanWidthMeta;
        const shaftDepthMMeta = this.props.shaftDepthMMeta;
        const slopeAngleN1Meta = this.props.slopeAngleN1Meta;
        const shaftCapacityM3PerHourMeta = this.props.shaftCapacityM3PerHourMeta;

        const numTubes = this.props.numTubes;
        const numTubesName = this.props.numTubesName;
        const tubeValuesNamePrefix = this.props.tubeValuesNamePrefix;
        const tubeValues = this.props.tubeValues;


        return (

            <div className="calculation-insertion-flexible-lining-info input-section">

                <CalculationSectionHeader text="Infodring flexibla foder" extraClass="page-break" id={ `iff-${this.props.phaseNr}` } />

                <div className="input-section-content">
                    <TubesInput numTubes={numTubes}
                                namePrefix={tubeValuesNamePrefix}
                                minTubes={1}
                                maxTubes={2}
                                values={tubeValues}
                                diaByTubeType={this.props.diaByTubeType}
                                metas={this.props.tubeMetas}
                                onChange={onChange}
                                onBlur={onBlur}
                                onUnmount={onUnmount}
                                numTubesName={numTubesName}
                                addTube={addTube}
                                removeTube={removeTube}
                                isNoDig={true}
                                phaseNr={this.props.phaseNr}
                                htmlHelpDia='Flexibelt foder ger i regel samma kapacitet som befintligt rör.'
                                tubeDiameterCallback={dependencyManager.getTubeDiametersIfl.bind(dependencyManager)}
                                tubeTypes={optionManager.availableSelections.tubeTypeIfl} />
    
                    <div className="row">
    
                        <NumberInput    htmlName="iflPointShafts"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        extraClassFormGroup="col-sm-6"
                                        labelText="Punktschakter för denna teknik"
                                        phaseNr={this.props.phaseNr}
                                        helpHtml='Antalet punktschakter anges och anpassas efter varje vald teknik. Om en punktschakt kan placeras på samma ställe för flera tekniker anges endast punktschakten för den teknik med djupast liggande rörtyp.'
                                        value={pointShafts}
                                        meta={pointShaftsMeta}
                                        min={0} />
    
                        { pointShafts > 0 &&
                        <NumberInput    htmlName="iflMetersLongerBottomLengthThanWidth"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        extraClassFormGroup="col-sm-6"
                                        labelText="Meter längre bottenlängd än bottenbredd"
                                        phaseNr={this.props.phaseNr}
                                        helpHtml="Anpassa bottenlängden efter vald teknik. För vissa tekniker krävs en något längre schakt för att rymma maskiner och utrustning."
                                        value={metersLongerBottomLengthThanWidth}
                                        meta={metersLongerBottomLengthThanWidthMeta}
                                        step={0.1}
                                        min={0} /> }
                    </div>
    
                    { pointShafts > 0 &&
                    <div className="row">
    
                        <NumberInput    htmlName="iflShaftDepthM"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        extraClassFormGroup="col-sm-6"
                                        labelText="Schaktdjup (m)"
                                        phaseNr={this.props.phaseNr}
                                        helpHtml='<img src="/images/shaft-params.png"/><br/><p>Välj ett schaktdjup som passar för det rör som ska ligga underst med denna teknik</p>'
                                        value={shaftDepthM}
                                        meta={shaftDepthMMeta}
                                        step={0.1}
                                        min={0} />
    
                        <DropDownInput htmlName="iflSlopeAngleN1"
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       onUnmount={onUnmount}
                                       extraClassFormGroup="col-sm-6"
                                       labelText="Släntlutning (N:1)"
                                       phaseNr={this.props.phaseNr}
                                       helpHtml='<img src="/images/shaft-params.png"/><br/><p>Välj en slätlutning som passar för schakten:<br/>1 = 1:1 bred schakt, <br/>5 = rak vägg med spont.</p>'
                                       value={slopeAngleN1}
                                       meta={slopeAngleN1Meta}
                                       includeEmptyOption={false}
                                       values={optionManager.availableSelections.slopeAngle} />
                    </div> }
    
                    {pointShafts > 0 &&
                    <div className="row">
    
                        <NumberInput    htmlName="iflShaftCapacityM3PerHour"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        extraClassFormGroup="col-sm-6"
                                        labelText="Schaktkapacitet (m³/tim)"
                                        phaseNr={this.props.phaseNr}
                                        helpHtml='Schaktkapaciteten beror på platsen och dess markförhållanden. I stadsmiljö är kapaciteten vanligtvis lägre (ex. 5 m³/tim) medan den kan vara högre på ängsmark (ex. 20 m³/tim).'
                                        value={shaftCapacityM3PerHour}
                                        meta={shaftCapacityM3PerHourMeta}
                                        min={0} />
    
                    </div> }
                </div>
            </div>
        );

    }

}

export default ReactAI.withTracking(CalculationInsertionFlexibleLiningInput);



// WEBPACK FOOTER //
// ./src/components/CalculationInsertionFlexibleLiningInput.js